import { createFileRoute } from '@tanstack/react-router';
import { ForeignVendorCreateSheet } from '@/pages/foreign-vendors/create-sheet';

export const Route = createFileRoute(
  '/admin/_layout/foreign-vendors/_layout/new'
)({
  component: () => <ForeignVendorCreateSheet />,
});
